import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const DayLabel = styled.div`
  border-bottom: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.subtle};
  padding-bottom: ${props => props.theme.spacing.sp8};
`

export const EventsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
`
